import React, { memo } from 'react';
import iso from 'iso-3166-1';

const SidebarCountryFlag: React.FC<{ country: string }> = ({ country }) => {
  const countryData = iso.whereCountry(country);
  if (countryData) {
    const flagClass = 'flag flag-' + countryData.alpha2.toLowerCase();
    return <span className={flagClass} />;
  }

  return null;
};

export default memo(SidebarCountryFlag);
